import React from 'react';
import { useInTesting } from '../hooks/useInTesting';

interface InTestingComponentProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Wrapper component for features that are still in testing.
 * Only renders children for SuperAdmins with testing mode enabled.
 *
 * Usage:
 *   <InTestingComponent>
 *     <NewFeatureButton />
 *   </InTestingComponent>
 *
 * With fallback:
 *   <InTestingComponent fallback={<OldFeatureButton />}>
 *     <NewFeatureButton />
 *   </InTestingComponent>
 *
 * To enable testing mode:
 *   1. Log in as SuperAdmin
 *   2. Press 't' twice quickly (within 500ms)
 *   3. Testing mode persists in localStorage
 */
const InTestingComponent: React.FC<InTestingComponentProps> = ({ children, fallback = null }) => {
  const { canSeeTestingFeatures } = useInTesting();

  if (canSeeTestingFeatures) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export default InTestingComponent;
